<template>
    <div class="inner-wrapper">
   <!--<div class="page-title">
      <h1 class="float-left">Edit Customer</h1>
   </div>-->
   <form @submit.prevent="save" id="addCustomerForm" name="addCustomerForm" method="post">
      <div class="new-rfq editcustomersec">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="alert alert-danger alert-dismissible" v-if="errorMessage !=null">
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    <strong class="success_msg">{{errorMessage}}</strong>
                </div>
                <div class="alert alert-success succ_msg" v-if="successMessage !=null">
                    <strong class="success_msg">{{successMessage}}</strong>
                </div>
                <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    <ul>
                        <li v-for="(v, k) in commonErrors" :key="k">
                        <p v-for="error in v" :key="error" class="text-sm">
                        {{ error }}
                        </p>
                        </li>
                    </ul>
                </div>
                </div>
            <div class="col-lg-12 col-md-12">
                <div class="card panel create-box mb-3">

                    <div class="card-body pb-0">
                        <h2 class="mb-3 inner-title">Information</h2>
                        <div class="row customcolSection">
                            <div class="col-lg-3 col-md-3">
                                <div class="form-group flex-fill">
                                    <label>Name</label>
                                    <input type="text" class="form-control" name="company_name" placeholder="" v-model="form.name">
                                </div>
                            </div>
                            <!-- <div class="col-lg-3 col-md-3">
                                <div class="form-group flex-fill">
                                    <label>Description</label>
                                    <input type="text" class="form-control" name="company_name" placeholder="" v-model="form.description">
                                </div>
                            </div> -->
                            <div class="col-lg-3 col-md-3">
                                
                                <div class="form-group flex-fill">
                                    <!-- <label>Address</label> -->
                                    <GooglePlaceAutoComplete v-if="loadMap"
                                                                :title="'Address'"
                                                                :placeholder="'Address'"
                                                                :errors="null"
                                                                v-model="form.address"
                                                                @selectedEvent="selectCompanyAddress"></GooglePlaceAutoComplete>

                                    <!-- <input type="text" class="form-control" name="address" placeholder="Company Address" v-model="form.address"> -->
                                </div>
                            </div>
                             <div class="col-lg-3 col-md-3">
                                
                                <div class="form-group flex-fill">
                                    <label>Address 2</label>
                                    <input type="text" class="form-control" name="address" placeholder="Company Address" v-model="form.address2">
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3">
                                <div class="form-group flex-fill">
                                    <label>Country</label>
                                    <select class="form-control" id="country_id" name="country_id" v-model="form.country_id">
                                        <option value="null">Select Country</option>
                                        <option v-for="country in customerData.countries" :value="country.id">{{country.name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 ">
                                <div class="form-group flex-fill">
                                    <label>City</label>
                                    <input type="text" class="form-control" placeholder="" name="fax" id="phone" v-model="form.city" />
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 ">
                                <div class="form-group flex-fill">
                                    <label>Post Code</label>
                                    <input type="text" class="form-control" placeholder="" name="email" id="email" v-model="form.post_code" />
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 ">
                                <div class="form-group flex-fill">
                                    <label>State</label>
                                    <input type="text" class="form-control" placeholder="" name="email" id="email" v-model="form.state" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                </div></div>

            

                

        

        
            <div class="btnrow text-right mb-2">
                <router-link :to="{name: 'viewCustomers'}" class="btn btn-danger me-1 active">Discard</router-link>
                <button type="submit" class="btn btn-primary" id="save_customer_btn">Save</button>
                <!-- <a href="#" class="btn custom-btn ml-3">Save</a> -->
            </div>
      </div>
   </form>
   <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
</div>
</template>
<script>
import { ValidationObserver,ValidationProvider, extend,validate  } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import GooglePlaceAutoComplete from "../../components/GooglePlaceAutoComplete";
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
// with typescript
for (let [rule, validation] of Object.entries(rules)) {
  extend(rule, {
    ...validation
  });
}
export default {
    name: "CustomerEdit",
     components: {
        ValidationProvider,ValidationObserver,
         GooglePlaceAutoComplete
    },
    created() {
        if(localStorage.getItem('token')){
             console.log("token "+localStorage.getItem('token'));
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
        this.getCustomer();
        this.getSalesRep();
        this.setSuccessMessage(null);
    },
    mounted() {
        this.loadMap = true;
    },
    data(){
        return {
            loadMap: false,
            salesRep: {
                data:[]
            },
            contactTypes: [],
            customerData: {
                customer: null,
                contacts: [],
                country_data: null,
                customer_contact: null,
                countries: [],
                can_add_customer: false,
                can_edit_customer: false,
                can_delete_customer: false,
                user_type: null,
                role: null
            },
            form: {
                id: null,
                name: null,
                description: null,
                address: null,
                address2: null,
                city: null,
                post_code: null,
                state: null,
                country_id: null,
                warehouse:{

                }
            }
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading'
        ]),
        selectCompanyAddress(place){
            let country = place.address_components.find((x) => x.types.includes('country'));

            if(country) {
                let selectedCountry = this.customerData.countries.find((x) => x.code === country.short_name);
                if(selectedCountry) {
                    this.form.country_id = selectedCountry.id;
                }
            }

            


            let lat = place.geometry.location.lat();
            let lng = place.geometry.location.lng();
            let neighborhood = place.address_components.find((x) => x.types.includes('neighborhood'));
            let sublocality = place.address_components.find((x) => x.types.includes('sublocality'));
            let locality = place.address_components.find((x) => x.types.includes('locality'));
            let pinCode = place.address_components.find((x) => x.types.includes('postal_code'));
            let state = place.address_components.find((x) => x.types.includes('administrative_area_level_1'));
            let city = place.address_components.find((x) => x.types.includes('administrative_area_level_3'));
            //let country = place.address_components.find((x) => x.types.includes('country'));
            //console.log("locality",locality);
            let address = '';
            if(neighborhood) {
                address += neighborhood.long_name;
            }
            if(sublocality) {
                address += address.length > 0 ?', ' : '';
                address += sublocality.long_name;
            }
            if(locality) {
                address += address.length > 0 ?', ' : '';
                address += locality.long_name;
            }

            if(address == '') {
                address = place.formatted_address;
            }

            if(place.name != '') {
                if(!this.form.address2 || this.form.address2 === ''){
                   // this.form.shipping[index].address2 = place.name;
                }
                //this.form.shipping[index].address = place.name+' , '+place.formatted_address;
                //alert("place.name"+place.name);
                this.form.address = place.name;
            }
            else{
                
                //this.form.shipping[index].address = place.formatted_address;
                this.form.address = address;
            }

            this.form.post_code = null;
            if(pinCode) {
                this.form.post_code = pinCode.long_name;
            }
            
            this.form.city = null;

            
            if(neighborhood) {
                console.log("city",neighborhood);
                this.form.city = neighborhood.long_name;
               // console.log("this.form.shipping[index].city",this.form.shipping[index].city);
            }
            if(!neighborhood && locality) {
                console.log("city",locality);
                this.form.city = locality.long_name;
               // console.log("this.form.shipping[index].city",this.form.shipping[index].city);
            }
            if(!neighborhood &&  !locality && city) {
                console.log("city",locality);
                this.form.city = city.long_name;
                //console.log("this.form.shipping[index].city",this.form.shipping[index].city);
            }
            
            
            this.form.state = null;
            if(state) {
                this.form.state = state.short_name;
            }

        },
        selectShippingAddress(place, index){
            let lat = place.geometry.location.lat();
            let lng = place.geometry.location.lng();
            let neighborhood = place.address_components.find((x) => x.types.includes('neighborhood'));
            let sublocality = place.address_components.find((x) => x.types.includes('sublocality'));
            let locality = place.address_components.find((x) => x.types.includes('locality'));
            let pinCode = place.address_components.find((x) => x.types.includes('postal_code'));
            let state = place.address_components.find((x) => x.types.includes('administrative_area_level_1'));
            let city = place.address_components.find((x) => x.types.includes('administrative_area_level_3'));
            let country = place.address_components.find((x) => x.types.includes('country'));

            let address = '';
            if(neighborhood) {
                address += neighborhood.long_name;
            }
            if(sublocality) {
                address += address.length > 0 ?', ' : '';
                address += sublocality.long_name;
            }
            if(locality) {
                address += address.length > 0 ?', ' : '';
                address += locality.long_name;
            }

            if(address == '') {
                address = place.formatted_address;
            }

            if(place.name != '') {
                if(!this.form.shipping[index].address2 || this.form.shipping[index].address2 === ''){
                    this.form.shipping[index].address2 = place.name;
                }
                //this.form.shipping[index].address = place.name+' , '+place.formatted_address;
                this.form.shipping[index].address = address;
            }
            else{
                //this.form.shipping[index].address = place.formatted_address;
                this.form.shipping[index].address = address;
            }

            this.form.shipping[index].post_code = null;
            if(pinCode) {
                this.form.shipping[index].post_code = pinCode.long_name;
            }
            this.form.shipping[index].city = null;
            if(city) {
                this.form.shipping[index].city = city.long_name;
            }
            this.form.shipping[index].state = null;
            if(state) {
                this.form.shipping[index].state = state.long_name;
            }

        },
        onContactTypeSelect(event, index){
            console.log(event)
            this.form.contacts[index].contact_type_ids = [];
            if (event) {
                event.forEach((x) => {
                    this.form.contacts[index].contact_type_ids.push(x.id);
                })
            }
        },
        onContactTypeDeSelect(event, index){
            console.log(event)
            this.form.contacts[index].contact_type_ids = [];
            if (event) {
                event.forEach((x) => {
                    this.form.contacts[index].contact_type_ids.push(x.id);
                })
            }
        },
        addNewShipping(){
            this.form.shipping.push({
                id:null,
                is_default:false,
                address2:null,
                address:null,
                state:null,
                city:null,
                post_code:null,
            });

            console.log(this.form.shipping.length);
        },
        removeContactShipping(index){
            this.form.shipping.splice(index, 1);
        },
        getSalesRep() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('sales-reps.index'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.salesRep = data.data.saleUsers;

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getContactTypes() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('getContactTypes'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors && data.errors.length){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.contactTypes = data.data;
                        this.form.contacts.forEach((contact) => {
                            contact.contact_types = this.contactTypes.filter((x) => contact.contact_type_ids.includes(x.id));
                        });
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);
                })
                .finally(() => {
                    self.setCustomerLoading(false);
                });
        },
        getCustomer() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            //this.setSuccessMessage(null);
            return axios.get(window.route('store-warehouse.show', {id: this.$route.params.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.customerData = data.data;
                        

                        this.form.id = data.data.customer.id;
                        this.form.name = data.data.customer.name;
                        this.form.description = data.data.customer.description;
                        this.form.address = data.data.customer.address;
                        this.form.address2 = data.data.customer.address2;
                        this.form.city = data.data.customer.city;
                        this.form.post_code = data.data.customer.post_code;
                        this.form.state = data.data.customer.state;
                        this.form.country_id = data.data.customer.country_id;
                        this.form.warehouse = data.data.customer.warehouse;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
            
        save() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.put(window.route('store-warehouse.update', {id: this.$route.params.id}), this.form, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        self.setSuccessMessage(data.data);
                       // self.getCustomer();
                        setTimeout(() => {
                            //self.$router.push({ name: 'viewCustomers' });
                            //self.$router.push({ name: 'customerDetails',  params: {id: self.$route.params.id} });
                            self.$router.push({ name: 'viewWarehouse' });
                        }, 3500);

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customers',
            'customersLoading'
        ])
    }
}
</script>

<style scoped>

</style>
